import React, { useState } from 'react'
// import "./PeopleReview.css"

const reviews = [
  {
    image: 'https://via.placeholder.com/100?text=1',
    comment: 'Review from person 1',
    name: 'Person 1',
  },
  {
    image: 'https://via.placeholder.com/100?text=2',
    comment: 'Review from person 2',
    name: 'Person 2',
  },
  {
    image: 'https://via.placeholder.com/100?text=3',
    comment: 'Review from person 3',
    name: 'Person 3',
  },
  {
    image: 'https://via.placeholder.com/100?text=4',
    comment: 'Review from person 4',
    name: 'Person 4',
  },
  {
    image: 'https://via.placeholder.com/100?text=5',
    comment: 'Review from person 5',
    name: 'Person 5',
  }
]

const CARD_WIDTH = 300
const OVERLAP_PERCENT = 30
const OVERLAP_OFFSET = (CARD_WIDTH * OVERLAP_PERCENT) / 100 // 60px

const PeopleReview = () => {
  const [centerIndex, setCenterIndex] = useState(2)

  const handleLeft = () => {
    setCenterIndex((prev) => (prev - 1 + reviews.length) % reviews.length)
  }

  const handleRight = () => {
    setCenterIndex((prev) => (prev + 1) % reviews.length)
  }

  const getCardStyle = (index) => {
    const total = reviews.length
    const relativeIndex = ((index - centerIndex + total) % total)
    const centerPosition = Math.floor(total / 2)
    const positionOffset = relativeIndex - centerPosition

    let offset = positionOffset * (CARD_WIDTH - OVERLAP_OFFSET)
    let zIndex = 10 - Math.abs(positionOffset)
    let scale = positionOffset === 0 ? 1.1 : 0.9
    let opacity = Math.abs(positionOffset) > 2 ? 0 : 1
    let rotate = 'rotate(0deg)'


    // Tilt and color styling
    if (positionOffset === -2 || positionOffset === 3) {
      rotate = 'rotate(-5deg)'
    } else if (positionOffset === -1 || positionOffset === 2) {
      rotate = 'rotate(5deg)'
    }

    return {
      transform: `translateX(${offset}px) scale(${scale}) ${rotate}`,
      zIndex,
      opacity,
      transition: 'all 0.5s ease',
    }
  }

  const getCardClasses = (index) => {
     const total = reviews.length
  let positionOffset = index - centerIndex

  // handle circular overflow
  if (positionOffset > total / 2) {
    positionOffset -= total
  } else if (positionOffset < -total / 2) {
    positionOffset += total
  }

    // Determine background class
     if (positionOffset === 2) {
    return 'bg-blue-100' // center card
     }
  else if (positionOffset === -2 || positionOffset === 1) {
    return 'bg-green-100' // neighbors
  }
   else if (positionOffset === -1 || positionOffset === 0) {
    return 'bg-yellow-100' }// outer cards
//   } else {
//     return 'bg-white'
//   }
  }

  return (
    <div className="w-full flex flex-col items-center justify-center py-10 overflow-hidden">
      <div className="relative flex justify-center items-center h-[400px] w-full max-w-6xl">
        {reviews.map((review, index) => (
          <div
            key={index}
            className={`absolute rounded-xl p-4 w-[300px] h-[300px] flex flex-col items-center justify-between shadow-lg ${getCardClasses(index)}`}
            style={getCardStyle(index)}
          >
            <img
              src={review.image}
              alt={review.name}
              className="w-20 h-20 rounded-full object-cover border-2 border-gray-300"
            />
            <p className="text-center text-gray-700 mt-4 px-2 text-sm">"{review.comment}"</p>
            <h4 className="mt-4 font-semibold text-gray-800">{review.name}</h4>
          </div>
        ))}
      </div>

      {/* Navigation Buttons */}
      <div className="mt-10 flex gap-6">
        <button
          onClick={handleLeft}
          className="px-4 py-2 bg-blue-200 hover:bg-blue-300 rounded-full text-xl"
        >
          ⬅
        </button>
        <button
          onClick={handleRight}
          className="px-4 py-2 bg-blue-200 hover:bg-blue-300 rounded-full text-xl"
        >
          ➡
        </button>
      </div>
    </div>
  )
}

export default PeopleReview
